export default __webpack_public_path__ + "static/media/rmc02.a79fb1a6.png";